import type { GameMode, PlayerSnapshot } from '../types';

interface LeaderboardProps {
  players: PlayerSnapshot[];
  mode?: GameMode;
  startedAt?: string;
  endedAt?: string | null;
}

function formatDuration(seconds: number): string {
  const totalSeconds = Math.max(0, Math.round(seconds));
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;
  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
}

function playerTime(player: PlayerSnapshot, startedAt?: string, endedAt?: string | null): number | null {
  const end = player.done_at ?? endedAt;
  if (!startedAt || !end) return null;
  return (new Date(end).getTime() - new Date(startedAt).getTime()) / 1000;
}

export function Leaderboard({ players, mode = 'competitive', startedAt, endedAt }: LeaderboardProps) {
  const scoreByTime = mode !== 'competitive' || players.length === 1;
  const ranked = [...players].sort((a, b) => {
    if (scoreByTime) {
      return (
        (playerTime(a, startedAt, endedAt) ?? Number.POSITIVE_INFINITY) -
          (playerTime(b, startedAt, endedAt) ?? Number.POSITIVE_INFINITY) ||
        a.name.localeCompare(b.name)
      );
    }
    return b.points - a.points || a.name.localeCompare(b.name);
  });

  return (
    <section className="leaderboard">
      <h2>Leaderboard</h2>
      {ranked.map((player, index) => (
        <div className="leaderboard-row" key={player.id}>
          <strong>{index + 1}</strong>
          <span>{player.name}</span>
          <span>
            {scoreByTime
              ? `${formatDuration(playerTime(player, startedAt, endedAt) ?? 0)}`
              : `${player.points} pts`}
          </span>
          <small>{player.words_completed} words</small>
        </div>
      ))}
    </section>
  );
}
